import { Cart } from 'src/services/types/joinEventV2'

/* eslint-disable @typescript-eslint/no-unsafe-return */
export const emptyCart: Cart = {
    challengeId: 0,
    athleteId: 0,
    userId: 0,
    challengeAthleteId: null,
    items: [],
    total: 0,
    subTotal: 0,
    discount: 0,
    finished: false,
    totalPrePromotion: 0,
    paid: false,
    transactionId: '',
    shippingRate: 0,
    internationalShipping: 0,
    internationalShippingRate: 0,
    success: false,
    message: '',
    charged: 0,
    hasError: false,
    forPerson: '',
    address: '',
    city: '',
    zip: '',
    stateId: 0,
    placeId: '',
    paymentMethod: 0,
    token: '',
    paymentID: '',
    payerID: '',
    authorizeID: '',
    orderID: '',
    paymentAmount: 0,
    isApproved: false,
    vouchers: [],
    isNew: false,
    userDataAPIId: 0,
    isPaused: false,
    orderSent: false,
    waiverAccepted: '',
    validicApp: '',
    activityType: '',
    predefinedGiftCard: null,
    fromNativeApp: false,
    bundle: {
        bundleId: null,
        bundleUrl: null,
        paymentId: null,
        name: null,
        challenges: []
    },
    salesTax: 0,
    salesTaxRate: 0,
    geoCounty: '',
    salesTaxable: 0,
    receiptUrl: '',
    membershipIncluded: false
}

export const getDerivedBundleAndCartState = (old_state, action) => {
    const state = old_state
    // if (state.cart.bundle.challenges.length > 0) {
    //     if (action.payload.cart.bundle.challenges.length > 0) {
    //     } else {
    //     }
    // } else {
    // }

    const challengesMap = new Map()
    action.payload.cart.bundle.challenges.forEach((item) =>
        challengesMap.set(item.challengeId, item)
    )
    state.cart.bundle.challenges.forEach((item) =>
        challengesMap.set(item.challengeId, item)
    )

    const mergeChallenges = Array.from(challengesMap.values()).map((itm) => {
        return {
            ...state.cart.bundle.challenges.find(
                (item) => item.challengeId === itm.challengeId && item
            ),
            ...itm,
            items:
                state.cart.bundle.challenges.find(
                    (item) => item.challengeId === itm.challengeId
                )?.items ?? itm.items
        }
    })

    const mergedBundle = {
        ...state.cart.bundle,
        ...action.payload.cart.bundle,
        paymentId: action.payload.cart.bundle.paymentId ?? state.cart.bundle.paymentId,
        challenges: mergeChallenges
    }

    const new_state = {
        challengeId: state.challengeId,
        rewards: state.rewards,
        addons: state.addons,
        cart: {
            ...action.payload.cart,
            challengeAthleteId: action.payload.cart.challengeAthleteId ?? null,
            // //GRM: when setting vouchers explicitly, the cart renders with the correct historical voucher, then gets replaced with a new one
            // //vouchers: state.cart.vouchers,
            // /*
            vouchers: action.payload.cart.vouchers.length
                ? action.payload.cart.vouchers
                : state.cart.vouchers,
            finished: false,
            authorizedAmount: 0,
            //Only replace the bundle in state if the server returned a bundle (in the case of a prewrapped bundle or a purchase)
            bundle: mergedBundle
        },
        receipt: emptyCart
    }

    if (new_state.cart.stateId === null) {
        new_state.cart.stateId = ''
    }
    //Look to see if the current race is part of the bundle and has add-on selections associated with it
    if (new_state.cart.bundle !== null && new_state.cart.bundle.challenges !== null) {
        const bundleChallenge = new_state.cart.bundle.challenges.find(
            (i) => i.challengeId === new_state.challengeId
        )
        if (bundleChallenge && bundleChallenge !== null) {
            bundleChallenge.items
                .filter((item) => item !== null)
                .forEach((bundleItem) => {
                    const item = new_state.rewards
                        .concat(new_state.addons)
                        .find((i) => i.challengeAddonId === bundleItem.challengeAddonId)
                    if (item && item !== null) {
                        item.selected = true
                        item.challengeAddonOptionId = bundleItem.challengeAddonOptionId
                    }
                })
        }
    }

    return new_state
}
